import { useCallback } from 'react';
import { BaseReaderStrategy } from './BaseReaderStrategy';
import Repository from 'repositories/Repository';
const { ReaderToolBarRepository } = Repository;

export const useInteractivityStudentStrategy = () => {
  const getReaderToolComponents = useCallback((readerToolComponents) => {
    return BaseReaderStrategy.getAcceptedReaderToolComponents(readerToolComponents, ReaderToolBarRepository.getInterativityStudentReaderToolBarWhitelist());
  }, []);

  const isReaderSwipeable = useCallback(() => {
    return true;
  }, []);

  const isReaderSwitchPageAvailable = useCallback(() => {
    return true;
  }, []);

  const syncAnnotation = useCallback((id) => {
    // Do nothing
  }, []);

  const syncSingleAnnotation = useCallback((annotatoin) => {

  }, []);

  const isInteractiveObjectTriggerable = useCallback(({ contentType }) => {
    return true;
  }, []);

  return {
    name: 'interactivityStudentStrategy',
    getReaderToolComponents,
    isReaderSwipeable,
    isReaderSwitchPageAvailable,
    syncAnnotation,
    syncSingleAnnotation,
    isInteractiveObjectTriggerable
  };
};
